import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  DrugReferenceFgNdcToBulkNdcPayload,
  DrugReferenceFgNdcToBulkNdcResponse,
  DrugReferenceFgNdcToBulkNdcSingleResponse
} from 'Interfaces/ReferenceInterfaces/DrugReferenceFgNdcToBulkNdcInterface';

export const drugReferenceFgNdcToBulkNdcServices = {
  getAllDrugReferenceFgNdcToBulkNdcs: (
    page = 1,
    pageSize = 10000,
    search?: string
  ): Promise<DrugReferenceFgNdcToBulkNdcResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = `pps/drug-reference-fg-ndc-to-bulk-ndcs?page=${page}&page_size=${pageSize}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }

        const { data } = await getRequest<DrugReferenceFgNdcToBulkNdcResponse>(url);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getDrugReferenceFgNdcToBulkNdcById: (
    id: number
  ): Promise<DrugReferenceFgNdcToBulkNdcSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<DrugReferenceFgNdcToBulkNdcSingleResponse>(
          `pps/drug-reference-fg-ndc-to-bulk-ndcs/${id}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createDrugReferenceFgNdcToBulkNdc: (
    drugReferenceData: DrugReferenceFgNdcToBulkNdcPayload
  ): Promise<DrugReferenceFgNdcToBulkNdcSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<DrugReferenceFgNdcToBulkNdcSingleResponse>(
          'pps/drug-reference-fg-ndc-to-bulk-ndcs/',
          drugReferenceData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateDrugReferenceFgNdcToBulkNdc: (
    id: number,
    drugReferenceData: DrugReferenceFgNdcToBulkNdcPayload
  ): Promise<DrugReferenceFgNdcToBulkNdcSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<DrugReferenceFgNdcToBulkNdcSingleResponse>(
          `pps/drug-reference-fg-ndc-to-bulk-ndcs/${id}/`,
          drugReferenceData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteDrugReferenceFgNdcToBulkNdc: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/drug-reference-fg-ndc-to-bulk-ndcs/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
